import { IMeters, isoMiles } from "../../models/nominals";
import { metersToMiles } from "../../utils/maps";

export const formatDistance = (
    distance: IMeters,
    decimalPoint?: number,
): string => {
    const miles = metersToMiles(distance);
    return isoMiles.unwrap(miles).toFixed(decimalPoint);
};

export const formatDistanceWithSuffix = (
    distance: IMeters,
    decimalPoint?: number,
): string => {
    const formattedDistance = formatDistance(distance, decimalPoint);
    // TODO(i18n): Use ngettext for plurals with full sentence: ngettext(msgid`${formattedDistance} mile`, `${formattedDistance} miles`, parseFloat(formattedDistance))
    const label = formattedDistance === "1" ? " mile" : " miles";
    return formattedDistance + label;
};
